<template>
    <div class="flex items-center gap-2">
        <h2 class="font-sans text-2xl font-semibold text-gray-800"><slot /></h2>
    </div>
</template>
